import React from 'react';
import Refunding from '@app/model/market_state/Refunding';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';
import { Tooltip } from 'react-tooltip';
import { flexIndicatorPresentation } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_calendar/fragment/FlexIndicator.utilities';

export const FlexIndicator: React.FunctionComponent<{
	competitorSnapshot: MarketStateStatDateCompetitorSnapshot,
	checkInDate: string
}> = ({ competitorSnapshot, checkInDate }) => {
	const tooltipId = React.useId();

	if (competitorSnapshot.isEmpty() || competitorSnapshot.isSoldOut()) return <div />;

	const item = competitorSnapshot.getLowestItemForRoom().lowestItem.item;
	if (item.refunding !== Refunding.FULL) return <div />;

	const presentation = flexIndicatorPresentation(item.cancellationDeadline, checkInDate);
	const linksToBooking = item.cancellationDeadline === 'partial';

	return <>
		<span
			className={presentation.isWide
				? 'inline-flex items-center justify-center rounded-md px-1.5 py-0.5 font-serif text-xs font-medium bg-slate-50 text-slate-800 ring-1 ring-inset ring-slate-700/10'
				: 'flex w-5 h-5 items-center justify-center rounded-full font-serif bg-slate-50 text-xs font-medium text-slate-800 ring-1 ring-inset ring-slate-700/10'}
			data-tooltip-content={linksToBooking ? undefined : presentation.tooltip}
			data-tooltip-id={tooltipId}>{presentation.label}</span>
		<Tooltip id={tooltipId} className="z-50" clickable={linksToBooking}>
			{linksToBooking && <span>
				Partially refundable — <a href="https://www.booking.com" target="_blank" rel="noreferrer" className="underline">Booking.com</a> keeps part of the price after a cancellation.
			</span>}
		</Tooltip>
	</>;
};
